import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/gemeente/";

const GemeenteApi = {
    getOpenAanvragenByGemeente(gemeenteId) {
        const serviceUrl = prependRoot(routePrefix + 'getopenaanvragenbygemeente/' + gemeenteId, getApiRoot());
        return axios.get(serviceUrl, {
            headers: { accept: "application/json" }
        });
    },
    createExportRequestForSportclubs(request) {
        const serviceUrl = prependRoot(routePrefix + 'createExportRequestSportclubs', getApiRoot());
        return axios.put(serviceUrl,
            request, {
            headers: {
                accept: "application/json"
            }
        });
    },
    getSportclubsByGemeenteByFilter(gemeenteId, filter) {
        const serviceUrl = prependRoot(routePrefix + 'getsportclubsbygemeentebyfilter/' + gemeenteId, getApiRoot());
        return axios.post(serviceUrl, filter, {
            headers: {
                'accept': 'application/json'
            }
        });
    },
    listSportclubsMarkers(gemeenteId) {
        const serviceUrl = prependRoot(routePrefix + 'listSportclubsMarkers/' + gemeenteId, getApiRoot());
        return axios.post(serviceUrl, {
            headers: {
                'accept': 'application/json'
            }
        });
    },
    findSpakkiUserId(ondernemingsnummer) {
        const serviceUrl = prependRoot(routePrefix + 'findSpakkiUserId/' + ondernemingsnummer, getApiRoot());
        return axios.get(serviceUrl, {
            headers: {
                'accept': 'application/json'
            }
        });
    }
};

export default GemeenteApi;
